import { lp } from "../utils/logPrefix";
import { guid } from "../utils/util";
import { IWsSentryReportArgs } from "./wsSentry";
import { showSentryDialog } from "./wsSentryDialog";

export function wsSentryReport(args: IWsSentryReportArgs): string {
  const correlationId = args.correlationId || guid();

  const { alreadyReported, additionalErrorMessageInfo } = args;

  if (args.error) {
    console.error(lp(), args.error);
  }

  const d = {
    ...args,
    alreadyReportedToSentry: true,
    correlationId,
    additionalErrorMessageInfo,
  };

  if (args.showDialog) {
    showSentryDialog(d);
  }

  return correlationId;
}
